import { useEffect, useRef, useState } from "react";
import { Button } from "@material-ui/core";
import iconDragDetail from "../icon-drag-detail.svg";
import TextareaAutosize from "react-textarea-autosize";
import iconTrash from "../icon-trash.svg";
import { ReactSortable } from "react-sortablejs";
import _, { cloneDeep, get, isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { nextArrowIcon } from "assets/icons";

import useStyles from "./styles";

const Step3 = (props: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { dataCreateIngredient } = useSelector((state: any) => state.recipe);
  let lastRef: any = useRef(null);
  const {
    onNextClick,
    onBackClick,
    register,
    getValues,
    setValue,
    handleSubmit,
    errors,
    onHandleCloseModal,
    listIngredients,
    setListIngredients,
    setEditRecipe,
    itemEdit,
    isEdit,
    setError,
    clearErrors,
  } = props;
  const [onEnterPressed, setOnEnterPressed] = useState(false);
  const idError = useRef(listIngredients?.length - 1);
  const configIngredient = {
    validate: (value: any) => {
      if (value?.trim() === "") {
        return "Please enter ingredient";
      }
      return true;
    },
  };

  const textFormRef = register(configIngredient);

  const getIdError = () => {
    idError.current = idError.current + 1;
    return idError.current;
  };

  const onchangeText = (e: any, key: number) => {
    listIngredients[key].content = e.target.value;
    setEditRecipe(true);
    setListIngredients(cloneDeep(listIngredients));
  };

  const handleShowContentMenu = async () => {
    const _data = [...listIngredients];
    _data.push({
      content: "",
      order: _data.length,
      idError: getIdError(),
      id: `delete${Math.random()}`,
    });
    setListIngredients(_data);
  };

  const swapError = (
    oldIndex: number,
    newIndex: number,
    listNewIndex: number[]
  ) => {
    if (get(errors, `ingredient${oldIndex}`)?.message) {
      const oldError = get(errors, `ingredient${oldIndex}`)?.message;
      setError(`ingredient${newIndex}`, { message: oldError });
      if (!listNewIndex?.includes(oldIndex)) {
        clearErrors(`ingredient${oldIndex}`);
      }
    }
  };

  const onchangeState = (newState: any) => {
    if (newState?.length > 0 && !_.isEqual(newState, listIngredients)) {
      const swapArray: any = [];
      const listNewIndex: any = [];
      _.map(listIngredients, (oldIngredient, index) => {
        if (get(errors, `ingredient${index}`)?.message) {
          const findIndex = _.findIndex(newState, (newIngredient: any) => {
            return newIngredient?.idError === oldIngredient?.idError;
          });
          if (parseInt(index) !== findIndex) {
            swapArray.push({ old: index, new: findIndex });
            listNewIndex.push(findIndex);
          }
        }
      });

      if (!isEmpty(swapArray)) {
        swapArray.map((item: any) => {
          swapError(parseInt(item?.old), item?.new, listNewIndex);
        });
      }

      const newListIngredients = _.map(newState, (item, index) => {
        return {
          ...item,
          position: index,
          id: item.id,
          order: index,
        };
      });
      setEditRecipe(true);
      setListIngredients(newListIngredients);
    }
  };

  const handleDeteleIngredient = async (indexDelete: number) => {
    const listIdSwaped: any = [];
    clearErrors(`ingredient${indexDelete}`);
    for (let i = indexDelete; i < listIngredients?.length - 1; i++) {
      swapError(i + 1, i, listIdSwaped);
      listIdSwaped.push(i);
    }
    // if (listIngredients[indexDelete]?.id) {
    //   dispatch(deleteIngredient(itemEdit.id, listIngredients[indexDelete]?.id));
    // }
    let _listIngredients = _.clone(listIngredients);
    _listIngredients.splice(indexDelete, 1);
    const newListIngredients = _.map(_listIngredients, (item, index) => {
      return {
        ...item,
        order: index,
      };
    });
    if (listIngredients?.length === 1) {
      setListIngredients([
        {
          content: "",
          order: 0,
          idError: getIdError(),
          id: `delete${Math.random()}`,
        },
      ]);
    } else {
      setListIngredients(newListIngredients);
    }
    setEditRecipe(true);
  };

  const renderIconTrash = (indexItemDeleted: any) => {
    return (
      <span
        className="content-trash"
        onClick={() => handleDeteleIngredient(indexItemDeleted)}
      >
        <img className={classes.iconTrash} src={iconTrash} alt="" />
      </span>
    );
  };

  const onNextStep3 = () => {
    if (isEdit) {
      const newListIngredients = _.cloneDeep(listIngredients).map(
        (item: any) => {
          return {
            ...item,
            id: item?.id || 0,
          };
        }
      );
      // TODO: call API STEP 4
      setListIngredients(newListIngredients);
      // dispatch(
      //   createIngredient(itemEdit.id, { ingredients: newListIngredients })
      // );
    }
    onNextClick();
  };

  useEffect(() => {
    if (dataCreateIngredient) {
      let cloneList = cloneDeep(listIngredients);
      cloneList[parseInt(dataCreateIngredient?.order)] = dataCreateIngredient;
      setListIngredients(cloneList);
    }
  }, [dataCreateIngredient]);

  useEffect(() => {
    const shouldReset = _.find(listIngredients, (item) => {
      return !item?.idError;
    });

    if (shouldReset) {
      const newListIngredients = _.map(listIngredients, (item) => {
        return {
          ...item,
          idError: item?.idError ? item?.idError : getIdError(),
        };
      });
      setListIngredients(newListIngredients);
    } else {
      listIngredients.map((item: any, index: any) => {
        setValue(`ingredient${index}`, item?.content);
      });
    }

    if (lastRef.current && onEnterPressed) {
      lastRef.current.focus();
      setOnEnterPressed(false);
    }
  }, [listIngredients]);

  const renderViewBottom = () => {
    return (
      <div className={classes.footerModal}>
        <button className={classes.cancelButton} onClick={onHandleCloseModal}>
          Cancel
        </button>
        <button className={classes.backButton} onClick={onBackClick}>
          Back
        </button>
        <button
          className={classes.nextButton}
          onClick={handleSubmit(onNextStep3)}
        >
          Next
          <div className={classes.nextButtonIconContainer}>
            <img src={nextArrowIcon} alt="Next Button Icon" />
          </div>
        </button>
      </div>
    );
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      event.preventDefault();
      setOnEnterPressed(true);
      handleShowContentMenu();
    }
  };

  return (
    <div className={classes.rootContainer}>
      <div className={classes.container}>
        <ReactSortable
          handle={".drag-handle"}
          list={listIngredients}
          setList={(newState: any) => onchangeState(newState)}
          direction={"vertical"}
          forceFallback={true}
        >
          {listIngredients.map((item: any, index: any) => {
            return (
              <div key={item?.id} className={`${classes.divFlex} text-area`}>
                <img src={iconDragDetail} alt="" className="drag-handle" />
                <div className={classes.divSubsection}>
                  <span>
                    {itemEdit ? parseInt(item?.order) + 1 : index + 1}.
                  </span>
                  <div style={{ width: "100%" }}>
                    <TextareaAutosize
                      className={classes.inputSubsection}
                      placeholder={`Type an ingredient here...`}
                      maxLength={1000}
                      onKeyDown={handleKeyDown}
                      ref={(e) => {
                        textFormRef(e);
                        if (index === listIngredients.length - 1) {
                          lastRef.current = e;
                        } else {
                          lastRef.current = undefined;
                        }
                      }}
                      onChange={(e: any) => onchangeText(e, index)}
                      name={`ingredient${index}`}
                    />
                    {get(errors, `ingredient${index}`)?.message && (
                      <p style={{ color: "red" }}>
                        {get(errors, `ingredient${index}`)?.message}
                      </p>
                    )}
                  </div>
                </div>
                {renderIconTrash(index)}
              </div>
            );
          })}
        </ReactSortable>
        <Button
          variant="text"
          className={classes.btnAddContent}
          onClick={handleShowContentMenu}
        >
          <span>+ Add another</span>
        </Button>
      </div>
      {renderViewBottom()}
    </div>
  );
};

export default Step3;
